import { SectionWhiteBox } from 'shared/ui/atoms/section-white-box';
import styled from 'styled-components';

export const StyledWrapper = styled(SectionWhiteBox)`
    padding: 20px; 
    iframe {
        border-radius: 12px;
    }
`;
